import React from 'react';
import IntegrationView from '../../../../SiteAdminView/IntegrationView';

const TemplateTab = () => (
  <IntegrationView
    templateView
    siteView={false}
  />
);

export default TemplateTab;
